__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "jdfy-ui";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("i18next", "23.16.8", () => (__webpack_require__.e("vendors-node_modules_i18next_dist_esm_i18next_js").then(() => (() => (__webpack_require__(/*! ./node_modules/i18next/dist/esm/i18next.js */ "./node_modules/i18next/dist/esm/i18next.js"))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__(/*! ./node_modules/react-dom/index.js */ "./node_modules/react-dom/index.js"))))));
			register("react-i18next", "15.7.4", () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-i18next_dist_es_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__(/*! ./node_modules/react-i18next/dist/es/index.js */ "./node_modules/react-i18next/dist/es/index.js"))))));
			register("react", "18.3.1", () => (__webpack_require__.e("vendors-node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! ./node_modules/react/index.js */ "./node_modules/react/index.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};